import React from 'react'
import GenericIcon from 'components/GenericIcon'

class ExpenseCheckbox extends React.Component {
  render() {
    const {
      id,
      text,
      checked,
      iconName,
      focusedInput,
    } = this.props
    const marginTop = text.length < 48 ? 'expense-text-padding-top' : ''
    const focusedIconName = focusedInput === id ? iconName + 'Focus' : iconName

    return (
      <div className='expense-checkbox col-auto'>
        <div className={`custom-control`}>
          <div className="label-icon">
            <GenericIcon name={ focusedIconName } className="mr-1 align-self-center"/>
          </div>
          <div className={`expense-text ${marginTop}`}>
            <span className="smaller">{text}</span>
          </div>
        </div>
      </div>
    )
  }
}

export default ExpenseCheckbox;
